'use client'

import { useMemo } from 'react'

export function ShortcutDisplay() {
  const shortcut = useMemo(() => {
    const platform = navigator.userAgent.toLowerCase()
    return platform.includes('mac') ? '⌘K' : 'CTRL+K'
  }, [])

  return (
    <div className='text-xs text-tertiary font-normal font-sans px-2 py-1 rounded-lg bg-surface1'>
      <span>{shortcut}</span>
    </div>
  )
}
